export default __webpack_public_path__ + "static/media/hub-dashboard.6e50bbbb.JPG";